import { IChieuCaoCanNangSelectByLopRequest } from "../model/request/sis/IChieuCaoCanNangSelectByLopRequest";
import { IReadUploadedExcelFileRequest } from "../models/request/upload-file/IReadUploadedExcelFileRequest";
import { IChieuCaoCanNang } from "../model/respone/sis/IChieuCaoCanNang";
import { apiClient } from "./apiClient";

export const chieuCaoCanNangApi = {
    selectByLop: (request: IChieuCaoCanNangSelectByLopRequest) =>
        apiClient.get(`chieu-cao-can-nang/nam-hoc/${request.nam_hoc}/lop/${request.dm_lop_id}/thang/${request.thang ?? 0}`),
    selectByTruong: (nam_hoc: string, dm_truong_id: number) =>
        apiClient.get(`chieu-cao-can-nang/nam-hoc/${nam_hoc}/truong/${dm_truong_id}`),
    selectByHocSinh: (nam_hoc: string, ts_hocsinh_id: number) => apiClient.get(`chieu-cao-can-nang/nam-hoc/${nam_hoc}/hoc-sinh/${ts_hocsinh_id}`),
    selectTrangThai: (type: number) => apiClient.get(`chieu-cao-can-nang/trang-thai?type=${type}`),
    save: (model: IChieuCaoCanNang) => apiClient.post(`chieu-cao-can-nang`, model),
    delete: (id: number) => apiClient.delete(`chieu-cao-can-nang/${id}`),
    ValidateImport: (data: IReadUploadedExcelFileRequest, dm_truong_id: number) => apiClient.post(`chieu-cao-can-nang/validate-import/truong/${dm_truong_id}`, data),
    Import: (data: IReadUploadedExcelFileRequest, dm_truong_id: number, nam_hoc: string) => apiClient.post(`chieu-cao-can-nang/import/truong/${dm_truong_id}/${nam_hoc}`, data)
}
